import React, { Component } from 'react';
import { connect } from 'react-redux';

class ControlsLink extends Component {
  constructor(props){
    super(props);
    this.state = {
      cts_url: `${props.instanceConfig.cts_url}/controls`,
      risk_mapper_url: `${window.location.origin}${window.location.pathname}`,
      label: props.translations.control_verification,
      enable_cts_access: props.instanceConfig.enable_cts_access,
      language: props.language,
      plan_name: props.plan_name
    }
    
  }

  componentWillMount = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const cts_url = urlParams.get('cts_url');
    if (cts_url) {
      this.setState({cts_url})
    }
  }

  componentWillReceiveProps = (nextProps) =>{
    const {plan_name, language} = nextProps
    const label = nextProps.translations.control_verification
    this.setState({plan_name, language, label})
  }

  generateCVSUrl = () => {
    const {cts_url, risk_mapper_url, plan_name, language} = this.state
    const cvsURL = new URL(cts_url);
    if (plan_name) {
      cvsURL.searchParams.set('plan_name', plan_name);
    };
    cvsURL.searchParams.set('language', language.name);
    cvsURL.searchParams.set('risk_mapper_url', risk_mapper_url);
    return cvsURL.href
  }

  render() {
    const { label, enable_cts_access } = this.state
    let className = this.props.className ? this.props.className : "item"
    let rendered_link = (<div></div>);
    if (enable_cts_access){
      rendered_link = (
        <a class={className} href={ this.generateCVSUrl() }>
          {
            (className == "item") ?
            (<span class="sidebar-button-wrap"><i aria-hidden="true" class="setting icon"></i><div>{label}</div></span>) : 
            label
          }
        </a>
      )
    }

    return rendered_link
  }
}

const mapStateToProps = (state) => {
  return {
    translations: state.language.language.translations,
    instanceConfig: state.instance.instanceConfig,
    language: state.language.language
  }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(ControlsLink)



// WEBPACK FOOTER //
// ./src/components/controls_link.js